// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___P3XIA","content":"styles__content___1TEec","icon":"styles__icon___1BeD2","return-link":"styles__return-link___EGGOk"};